/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：470
 */

"use strict"

var r
export { r as a };
(function (e) {
  e[e.NORMAL = 0] = "NORMAL"
  e[e.ELASTIC = 1] = "ELASTIC"
})(r || (r = {}))
export default r
